export interface EyeProps {
    w: number;
    h: number;
    offX: number;
    offY: number;
    blink: boolean;
}

export const EyeNormal = ({ w, h, offX, offY, blink }: EyeProps) => (
    <div
        style={{
            width: w,
            height: blink ? 5 : h,
            borderRadius: 9999,
            background: '#2a2a5c',
            transform: `translate(${offX}px, ${offY}px)`,
            transition: 'height 0.15s, width 0.15s',
        }}
    />
);

export const EyeHappy = ({ w, h, offX, offY, blink }: EyeProps) =>
    blink ? (
        <div
            style={{
                width: w,
                height: 5,
                borderRadius: 9999,
                background: '#2a2a5c',
                transform: `translate(${offX}px, ${offY}px)`,
                transition: 'height 0.15s',
            }}
        />
    ) : (
        <svg
            width={w}
            height={h}
            viewBox={`0 0 ${w} ${h}`}
            style={{
                transform: `translate(${offX}px, ${offY}px)`,
                overflow: 'visible',
            }}
        >
            <path
                d={`
        M 0,${h * 0.85}
        L 0,${h * 0.4}
        A ${w / 2},${h * 0.4} 0 0,1 ${w},${h * 0.4}
        L ${w},${h * 0.85}
        C ${w},${h} ${w * 0.7},${h * 0.7} ${w / 2},${h * 0.7}
        C ${w * 0.3},${h * 0.7} 0,${h} 0,${h * 0.85}
        Z
      `}
                fill="#2a2a5c"
            />
        </svg>
    );

export const EyeSad = ({ w, h, offX, offY, blink }: EyeProps) => (
    <div
        style={{
            width: blink ? w * 1.2 : w,
            height: blink ? 5 : h,
            borderRadius: blink ? '0 0 9999px 9999px' : 9999,
            background: '#2a2a5c',
            transform: `translate(${offX}px, ${offY}px)`,
            transition: 'height 0.3s, width 0.3s, border-radius 0.3s',
        }}
    />
);

export const EyeSadLeft = (props: EyeProps) => <EyeSad {...props} />;
export const EyeSadRight = (props: EyeProps) => <EyeSad {...props} />;

export const EyeSleepy = ({ w, h, offX, offY }: EyeProps) => (
    <div
        style={{
            width: w,
            height: h,
            borderRadius: 9999,
            background: '#2a2a5c',
            transform: `translate(${offX}px, ${offY}px)`,
            transition: 'height 0.15s, width 0.15s',
        }}
    />
);
